import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Toggle} from '../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {PickTeammateWorkspacesDropdownBox} from '../../../components/common/dropdowns/tags/pickTeammateWorkspacesDropdownBox';
import {ShowTagInWorkspacesTooltip} from '../../../components/common/dropdowns/tags/tagEditorTooltips';
import {isTeammateNamespace} from '../../../helpers/models/namespaceHelpers';
import {TeammateModel} from '../../../models/api/teammateModel';
import {SettingsFieldLine} from '../../common/settingsFieldLine';

/*
 * Props.
 */

interface SettingsSingleTagWorkspaceFieldProps {
  namespace: string;
  showInPersonalWorkspaces: boolean;
  shouldShowTeammatePinFeature: boolean;
  onChange: HandlerOf<boolean>;
  teammates: ReadonlyArray<TeammateModel>;
  onTeammatesChange: HandlerOf<ReadonlyArray<number>>;
  selectedTeammateIds: ReadonlyArray<number>;
}

/*
 * Component.
 */

export const SettingsSingleTagWorkspaceField: FC<SettingsSingleTagWorkspaceFieldProps> = (props) => {
  const {
    namespace,
    shouldShowTeammatePinFeature,
    showInPersonalWorkspaces,
    onChange,
    teammates,
    onTeammatesChange,
    selectedTeammateIds,
  } = props;

  if (isTeammateNamespace(namespace)) {
    return (
      <SettingsFieldLine
        renderTooltip={() => <ShowTagInWorkspacesTooltip />}
        isTooltipMultiline
        title={<Trans id="settingstags-showpersonal-title">Show in my sidebar</Trans>}
        subtitle={<Trans id="settingstags-showpersonal-subtitle">Show this tag in my personal sidebar</Trans>}
        content={<Toggle isChecked={showInPersonalWorkspaces} onChange={onChange} />}
      />
    );
  }

  if (!shouldShowTeammatePinFeature) {
    return null;
  }

  const renderDropdownBox = () => (
    <PickTeammateWorkspacesDropdownBox
      namespace={namespace}
      teammates={teammates}
      selectedTeammateIds={selectedTeammateIds}
      onSelectedTeammatesChange={onTeammatesChange}
      shouldHideLabel
    />
  );

  return (
    <SettingsFieldLine
      renderTooltip={() => <ShowTagInWorkspacesTooltip />}
      isTooltipMultiline
      title={<Trans id="settingstags-show-title">Show in teammate sidebars</Trans>}
      subtitle={<Trans id="settingstags-show-subtitle">Show this tag for teammates who need to use it</Trans>}
      content={renderDropdownBox()}
    />
  );
};
